import React from "react";
import { useEffect, useState } from "react";
import { refreshToken } from "../utils/refresh";
import { useDispatch } from "react-redux";
import { store } from "../redux/store";
import BaseLoading from "../components/Loader/BaseLoading";
import Logout from "../utils/logout";
import AccountRevokedScreen from "../components/AccountRevoked/AccountRevokedScreen";
import { REVOKED_ACCOUNT_MESSAGE } from "../utils/authErrors";

const Refresh = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isRevoked, setIsRevoked] = useState(false);
  const [revokedMessage, setRevokedMessage] = useState(REVOKED_ACCOUNT_MESSAGE);
  const dispatch = useDispatch();

  useEffect(() => {
    const run = async () => {
      try {
        const session = await refreshToken(dispatch, () => store.getState());
        setIsAuthenticated(!!session);
        setIsRevoked(false);
      } catch (err: any) {
        if (err?.revoked) {
          setIsRevoked(true);
          setRevokedMessage(err.revokedMessage || REVOKED_ACCOUNT_MESSAGE);
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(false);
        }
      } finally {
        setIsLoading(false);
      }
    };
    run();
  }, [dispatch]);

  if (isLoading) {
    return <BaseLoading title="Loading..." />;
  }

  if (isRevoked) {
    return <AccountRevokedScreen message={revokedMessage} />;
  }

  if (!isAuthenticated) {
    return <Logout />;
  }

  return <>{children}</>;
};

export default Refresh;
